// UI
export const TEMPLATE_NAME = 'backInStock';

export const MODAL_OPEN_CLASS = 'modal-open-cart';
export const EMAIL_ERROR_MESSAGE = 'Please input a valid email address.';
export const SUCCESS_BANNER_TIMEOUT = 5000;

// CSS class names
export const CLASS_BOOST_SD_BIS_NOTIFY_POPUP_SHOWED = 'boost-sd__bis-notify-popup--showed';
export const CLASS_BOOST_SD_BIS_EMAIL_INPUT_ERROR = 'boost-sd__bis-email-input--error';
export const CLASS_BOOST_SD_BIS_SUBMIT_BUTTON_ACTIVE = 'boost-sd__bis-submit-button--active';
export const CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_LIST_OPEN =
  'boost-sd__bis-dropdown-option-list--open';
export const CLASS_BOOST_SD_BIS_DROPDOWN_OPTION_ITEM_SELECTED =
  'boost-sd__bis-dropdown-option-item--selected';
export const CLASS_BOOST_SD_BIS_SUCCESS_BANNER_SHOWED = 'boost-sd__bis-success-banner--showed';

// Element IDs
export const ID_NOTIFY_BUTTON = 'boost-sd__bis-notify-me-button';
export const ID_POPUP = 'boost-sd__bis-notify-popup';
export const ID_CLOSE_BUTTON = 'boost-sd__bis-close-popup';
export const ID_EMAIL_INPUT = 'boost-sd__bis-email-input';
export const ID_VARIANT_SELECT = 'boost-sd__bis-dropdown-variant';
export const ID_SUBMIT_BUTTON = 'boost-sd__bis-submit-button';
export const ID_ERROR_MESSAGE_ELEMENT = 'boost-sd__bis-email-error';
export const ID_SUCCESS_BANNER = 'boost-sd__bis-success-banner';
export const ID_SUCCESS_BANNER_TEXT = 'boost-sd__bis-success-banner-text';
export const ID_SUCCESS_BANNER_ICON = 'boost-sd__bis-success-banner-icon';
export const ID_BACK_IN_STOCK_CONTAINER = 'bc-bis';

// CSS Selectors
export const SELECTOR_DROPDOWN_SELECTED_OPTION = '.boost-sd__bis-dropdown-selected-option';
export const SELECTOR_DROPDOWN_OPTION_LIST = '.boost-sd__bis-dropdown-option-list';
export const SELECTOR_DROPDOWN_OPTION_ITEM = '.boost-sd__bis-dropdown-option-item';
export const SELECTOR_DROPDOWN_OPTION_TEXT = '.boost-sd__bis-dropdown-option-text';
export const SELECTOR_POPUP_TITLE = '.boost-sd__bis-popup-title';
export const SELECTOR_POPUP_DESCRIPTION = '.boost-sd__bis-popup-description';

// Other constants
export const MAX_ATTEMPTS = 10;
export const CHECK_DELAY = 250;
